// extracted by mini-css-extract-plugin
export default {"menuItem":"SidebarSubmenu_menuItem__JxuDq","active":"SidebarSubmenu_active__d1h+9"};